import React from 'react';
import { Box, Skeleton } from '@mui/material';
import ServeOrderCardSkeleton from 'components/ServeOrderCard/ServeOrderCardSkeleton';
import './style.css';

const ServeStatusColumnSkeleton = () => {
  return (
    <Box className="d-flex serve-status-column-container">
      {/* column header skeleton */}
      <Box
        className="status-column d-flex align-items-center justify-content-between"
        sx={{
          bgcolor: '#ECECEC',
          py: 1,
          px: 2,
          height: '42px',
          border: '1px solid #D6D6D6',
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
        }}
      >
        <Skeleton variant="text" width={120} height={24} animation="wave" />
        <Skeleton variant="circular" width={22} height={22} animation="wave" />
      </Box>

      {/* search box skeleton */}
      <Box className="search-box" sx={{ border: '1px solid #D6D6D6', borderTop: 'none', p: '15px 20px' }}>
        <Skeleton variant="rectangular" height={40} animation="wave" sx={{ borderRadius: '10px' }} />
      </Box>

      {/* item boxes container skeleton */}
      <Box
        className="search-orders-container"
        sx={{
          border: '1px solid #D6D6D6',
          borderTop: 'none',
          borderBottomLeftRadius: '10px',
          borderBottomRightRadius: '10px',
          p: '10px',
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          overflowY: 'hidden',
        }}
      >
        {Array.from({ length: 3 }).map((_, idx) => (
          <ServeOrderCardSkeleton key={idx} />
        ))}
      </Box>
    </Box>
  );
};

export default ServeStatusColumnSkeleton;
